export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const LOADING_MESSAGE = '正在获取区号列表...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_QRCODE_STATUS = 'SET_QRCODE_STATUS';
